import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=loading, false=guest, object=admin
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("xmd_token");
    if (!token) {
      setAdmin(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("xmd_token");
        setAdmin(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = (token, adminObj) => {
    localStorage.setItem("xmd_token", token);
    setAdmin(adminObj);
  };

  const logout = () => {
    localStorage.removeItem("xmd_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, checked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
